import { reactive, readonly, toRefs } from 'vue'

type Msg = {
  id?: number
  text: string
  level: 'success' | 'error' | 'warn' | 'info'
  options: { timeout?: number; content?: 'html' | 'text' }
}

const data = reactive({
  messages: [] as Msg[],
  counter: 0,
  paused: false,
})

export const messageService = readonly({
  ...toRefs(data),

  pause() {
    data.paused = true
  },

  resume() {
    data.paused = false
  },

  success(text: string, options: Msg['options'] = { timeout: 6000 }) {
    const msg: Msg = { text, level: 'success', options }
    this._addMessage(msg, options)
    return msg
  },

  error(text: string, options: Msg['options'] = { timeout: 6000 }) {
    const msg: Msg = { text, level: 'error', options }
    this._addMessage(msg, options)
    return msg
  },

  warn(text: string, options: Msg['options'] = { timeout: 6000 }) {
    const msg: Msg = { text, level: 'warn', options }
    this._addMessage(msg, options)
    return msg
  },

  info(text: string, options: Msg['options'] = { timeout: 6000 }) {
    const msg: Msg = { text, level: 'info', options }
    this._addMessage(msg, options)
    return msg
  },

  removeMessage(id: number | undefined) {
    data.messages = data.messages.filter((m) => m.id !== id)
  },

  _addMessage(msg: Msg, opts: Msg['options'] = { timeout: 6000 }) {
    if (data.paused) {
      return
    }
    msg.id = ++data.counter
    data.messages.push(msg)
    while (data.messages.length > 10) {
      data.messages.shift()
    }
    if (opts.timeout === 0) return
    if (typeof opts.timeout !== 'number') {
      return
    }
    setTimeout(() => this.removeMessage(msg.id!), opts.timeout)
  },
})
